import { render, staticRenderFns } from "./user-credit-edit.vue?vue&type=template&id=845294c4&"
import script from "./user-credit-edit.vue?vue&type=script&lang=js&"
export * from "./user-credit-edit.vue?vue&type=script&lang=js&"
import style0 from "./user-credit-edit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports